import { Components } from '@mui/material/styles';
import { tokens, radii } from '../foundations/tokens';
export const createDialogOverrides = (
  mode: 'light' | 'dark'
): Pick<
  Components,
  'MuiDialog' | 'MuiDialogContent' | 'MuiDialogTitle' | 'MuiDialogActions'
> => {
  const t = tokens(mode);
  return {
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: t.surfaces.panel,
          backgroundImage: 'none',
          border: `1px solid ${t.borders.control}`,
          borderRadius: radii['2xl'],
          boxShadow: t.shadows.modal,
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          backgroundColor: t.surfaces.fillSubtle,
          borderBottom: `1px solid ${t.borders.divider}`,
          padding: '20px 24px',
        },
      },
    },
    MuiDialogContent: { styleOverrides: { root: { padding: 24 } } },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: '16px 24px',
          borderTop: `1px solid ${t.borders.divider}`,
          gap: 8,
        },
      },
    },
  };
};
